import React from 'react';
import { BadgeAlert } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import themeStyles from './styles/AvailabilityStatusBadge.styles';
import { statusBadgeConfig } from '../constants';
const InventoryBadge = themeStyles.apply(BadgeAlert, 'InventoryBadge');
const AvailabilityStatusBadge = ({ status, styles }) => {
    const { t } = useTranslation();
    if (!status)
        return null;
    const { variant, icon, label } = statusBadgeConfig[status];
    return (React.createElement(InventoryBadge, { dataTestId: "dsr-availability-status-badge", variant: variant, labelText: t(label), iconSize: "default", iconName: icon, ...styles }));
};
export default AvailabilityStatusBadge;
